module.exports = __webpack_public_path__ + "static/media/logo-joyeria-blanco-500.3f1dd27f.png";